export default __webpack_public_path__ + "static/media/Emily-Pitzer.afe63bbb.png";